import { FilterField, labelId } from "kontrolEdge/helpers/advancedFilters";
import { InternetConnection } from "./InternetData";

function parseMbpsInput(raw: string): number | null {
  const s = raw.trim().toLowerCase().replace(/\s+/g, "").replace(/,/g, "");
  if (/(gbps?|g)b?$/.test(s)) {
    const n = Number(s.replace(/(gbps?|g)b?$/, ""));
    return Number.isFinite(n) ? n * 1000 : null;
  }
  if (/(mbps?|m)b?$/.test(s)) {
    const n = Number(s.replace(/(mbps?|m)b?$/, ""));
    return Number.isFinite(n) ? n : null;
  }
  const n = Number(s);
  return Number.isFinite(n) ? n : null;
}

// Accept DD/MM/YYYY, YYYY-MM-DD, etc.
function parseDateInput(raw: string): Date | null {
    const s = raw.trim();
    // allow 1–2 digits for day/month
    const m1 = s.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})$/); // D/M/YYYY or DD/MM/YYYY
    if (m1) {
        const [, dd, mm, yyyy] = m1;
        const d = new Date(Number(yyyy), Number(mm) - 1, Number(dd)); // local midnight
        return isNaN(d.getTime()) ? null : d;
    }
    const m2 = s.match(/^(\d{4})[/-](\d{1,2})[/-](\d{1,2})$/); // YYYY-M-D or YYYY-MM-DD
    if (m2) {
        const [, yyyy, mm, dd] = m2;
        const d = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
        return isNaN(d.getTime()) ? null : d;
    }
    const d = new Date(s); // ISO fallback
    return isNaN(d.getTime()) ? null : d;
    }
      

export function makeInternetFields(
  isViewingAllCustomers: boolean
): FilterField<InternetConnection>[] {
  const fields: FilterField<InternetConnection>[] = [
    {
      label: "Connection ID",
      key: "connectionid",
      accessor: (r) => r.subscriptionId,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Parent Connection",
      key: "parentconnection",
      accessor: (r) => r.parentConnection,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Name",
      key: "name",
      accessor: (r) => r.name,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Mbps",
      key: "mbps",
      accessor: (r) => r.mbpsNum,
      type: "number",
      inFreeText: true,
      parseRhs: parseMbpsInput,
    },
    {
      label: "VLAN",
      key: "vlan",
      accessor: (r) => r.vlan,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Routing",
      key: "routing",
      accessor: (r) => r.routing,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Term",
      key: "term",
      accessor: (r) => r.terms,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Renew Date",
      key: "renewdate",
      accessor: (r) => r.renewDateRaw,
      type: "date",
      inFreeText: true,
      parseRhs: parseDateInput,
    },
    {
      label: "Tag",
      key: "tag",
      accessor: (r) => (Array.isArray(r.tag) ? r.tag.join(" ") : r.tag ?? ""),
      type: "string",
      inFreeText: true,
    },
  ];

  if (isViewingAllCustomers) {
    fields.splice(1, 0, {
      label: "Customer",
      key: "customer",
      accessor: (r) => [
        r.customer?.name ?? "",
        r.customer?.chargebeeCustomerId ?? ""
      ].filter(Boolean).join(" "),
      type: "string",
      inFreeText: true,
    });
  }

  for (const f of fields) f.key ||= labelId(f.label);
  return fields;
}
